.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.player {
  width: 100%;
}

.instructions {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--tuna-spacing-2);
}

.control {
  min-width: 6rem;
}

.readout {
  font-size: var(--tuna-typography-body2-fontSize);
  font-variant-numeric: tabular-nums;
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}
